module.exports = __webpack_public_path__ + "static/media/tag.e5160df3.svg";